import { ThemeOptions } from "@mui/material";
import { grey, orange } from "@mui/material/colors";

export const theme: ThemeOptions = {
  palette: {
    mode: "dark",
    text: {
      primary: "#e6edf3",
      secondary: "#8b949e",
    },
    divider: "#2d333b",
    background: {
      default: "#0d1117",
      paper: "#161b22",
    },
    info: {
      dark: grey[400],
      main: grey[400],
      light: "#2d333b",
    },
    secondary: {
      dark: orange[300],
      main: orange[300],
    },
  },
};
